import { useParams, Link } from 'react-router-dom'
import styles from '../styles/Library.module.css'
import OptimizedImage from './OptimizedImage'

interface ImageCardProps {
  assetId: string,
  secureUrl: string,
  aspectRatio: number,
  context: {
    custom?: {
      name?: string
    }
    name?: string
  }
}

function ImageCard({assetId, secureUrl, aspectRatio, context}: ImageCardProps) {
  const { storeId, channelType } = useParams()

  return (
    <li className={styles.item}>
      <Link to={`/${storeId}/${channelType}/${assetId}/redigera`}>
        <OptimizedImage
          className={styles.image}
          src={secureUrl}
          aspectRatio={aspectRatio}
        />
        <div className={styles.imageName}>
          <span className={styles.imageNameText}>{context?.name ? context.name : (context?.custom?.name ? context.custom.name : 'Bildnamn saknas')}</span>
        </div>
      </Link>
    </li>
  )
}
  
export default ImageCard
  